import React, { useEffect } from "react";
import CaseHero from "../commonCase/CaseHero";
import icon from "../../../../assets/svgs/tankssvg.svg";
import website from "../../../../assets/images/tanksimg.webp";
import Task from "../commonCase/Task";
import Task1 from "../commonCase/Task1";
import work2 from "../../../../assets/images/tankswork2.webp";
import work1 from "../../../../assets/images/tankswork1.webp";
import Design from "../commonCase/Design";
import Work from "../commonCase/Work";
import Result from "../commonCase/Result";
import result1 from "../../../../assets/svgs/softsidecard1.svg";
import result2 from "../../../../assets/svgs/softsidecard2.svg";
import result3 from "../../../../assets/svgs/softsidecard3.svg";
import Data from "../../Data";
import softside from "../../../../assets/svgs/softsidesvg.svg";
import aes from "../../../../assets/svgs/aessvg.svg";
import OtherProject from "../commonCase/OtherProject";
import ggp from "../../../../assets/svgs/ggpsvg.svg";

const tableData = [
  { task: "Website Design & Dev", status: true },
  { task: "Branding", status: true },
];

const task1Data = [
  {
    subheading: "User Experience Check: ",
    des: "We closely studied how visitors were navigating the site, pinpointed friction points and looked for areas where users were dropping off or getting confused. ",
  },
  {
    subheading: "Site Speed Test: ",
    des: "We tested the site’s load times on both desktop and mobile. Slow websites frustrate users and hurt SEO, so we identified what was slowing things down and fixed it.  ",
  },
  {
    subheading: "Mobile Friendliness: ",
    des: "With a growing number of users browsing on mobile, we made sure every page loaded correctly, looked great and functioned smoothly across all screen sizes.",
  },
  {
    subheading: "Product Pages Review: ",
    des: "We reviewed layout, content, and visuals on each product page, ensuring they were informative, easy to scan, visually engaging and built trust with potential buyers.",
  },
  {
    subheading: "Checkout Flow Fixes: ",
    des: "We walked through the checkout experience as a customer would, identifying steps that confused and simplifying the process to reduce drop-offs and boost conversions.",
  },
];

const task2Data = [
  {
    subheading: "Logo Design: ",
    des: "Created a clean, modern logo that captures the brand’s personality and feels strong across digital and print.",
  },
];
const images = [work1, work2];

const cardData = [
  {
    icon: result1,
    subheading: "Enhanced Brand Identity",
    text: "We developed a cohesive branding strategy, including a modern logo, professional business cards and LinkedIn banners, which reinforced their reputation as a leader in industrial storage solutions.",
  },
  {
    icon: result2,
    subheading: "Optimized Website Performance",
    text: "Through a comprehensive website redesign, we improved site navigation and load times, ensuring that clients could easily access detailed product information and specifications.",
  },
  {
    icon: result3,
    subheading: "Improved Client Engagement",
    text: "The updated digital platforms facilitated better communication with clients, allowing for more efficient dissemination of technical resources and product details.",
  },
];
const project = [
  {
    name: "SoftSide",
    img: softside,
    link: "/case-study/softside",
  },
  {
    name: "AesRecruitment",
    img: aes,
    link: "/case-study/aes",
  },
  {
    name: "Global Growth Partners",
    img: ggp,
    link: "/case-study/ggp",
  },
];

const TanksAndCover = () => {
  useEffect(() => {
    // Set Page Title
    document.title = "SEO & Web Development Case Study | TechQilla";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "See how TechQilla delivered SEO and web development solutions that improved traffic, conversions, and online presence.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", "SEO & Web Development Case Study");
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute("href", "https://www.techqilla.com/case-study/tanksandcover");
  }, []);

  return (
    <div className="pt-[100px] lg:pt-[80px]">
      <CaseHero
        name="TanksandCovers"
        highlited="Tanksandcovers"
        title="Case Study for"
        icon={icon}
        subtitle="Website design and Development, Branding"
        date={2024}
      />
      <Task
        rows={tableData}
        bgColor="bg-[#F1593A]" // Custom background color
        headerColor="bg-[#333333]" // Custom header color
        className=""
        text1="TanksandCovers, a leader in industrial storage solutions, faced challenges in establishing a compelling digital presence. Their brand lacked a cohesive identity, and their online platforms weren't effectively conveying their expertise or attracting the right audience."
      />
      <Task1
        heading="Website Design"
        text="We kicked things off with a full site audit to uncover what was slowing things down or confusing users. Here's what we tackled:"
        list={task1Data}
        listcolor="text-[#F1593A]"
        listStyleColor="fill-[#F1593A]"
      />
      <Design
        heading="Website Design"
        bgcolor="bg-[#F1593A]"
        img={website}
        link="https://www.tanksandcovers.com/"
        linkName="www.tanksandcovers.com"
      />
      <Task1
        heading="Branding"
        text="We crafted a cohesive brand identity that reflects professionalism, trust and clarity across all key touchpoints."
        list={task2Data}
        listcolor="text-[#F1593A]"
        listStyleColor="fill-[#F1593A]"
      />
      <Work
        bgColor="bg-[#F1593A]"
        heading="Logo Design"
        img={images}
        grid="lg:grid-cols-2"
      />
      <Result
        cardColor="bg-[#333333]"
        heading="Results"
        text="Here’s what changed after we stepped in "
        cards={cardData}
      />
      <OtherProject project={project} />
      <Data />
    </div>
  );
};

export default TanksAndCover;
